<div class="bg-primary h-100vh">
    <grid-row class="justify-content-center align-content-center h-100">
        <grid-col col="5" class="text-align-center">
            <div class="text-align-center">
                <i class="icon-error-big"></i>
            </div>
            <div class="font-500 font-size-32px color-base-100 mt-25">
                {{ "Yourpaymentisunsuccessful" | translate }}
            </div>

            <div class="font-400 font-size-22px color-base-100 opacity-06">
              {{this.ErrorText}} 
            </div>
            <grid-row class="justify-content-center">
                <grid-col col="12">
                    <grid-row class="mt-30 justify-content-center">
                        <grid-col col="8">
                            <button class="btn-dft-border" [routerLink]="['/DashboardCreditCards']" *ngIf="this.prodType == 'C'">
                                <!-- DashboardLoans   Dashboard-->
                                {{ "BACKTODASHBOARD" | translate }}
                            </button>
                            <button class="btn-dft-border" [routerLink]="['/DashboardLoans']" *ngIf="this.prodType == 'L'">
                                <!-- DashboardLoans   Dashboard-->
                                {{ "BACKTODASHBOARD" | translate }}
                            </button>
                        </grid-col>
                    </grid-row>
                </grid-col>
            </grid-row>
        </grid-col>
    </grid-row>
</div>